var React = require('react');

function Register (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a6f244f0-8060-4ba8-a467-8f1a3dddc6f4{fill:#fff;fill-rule:evenodd;}")),React.createElement("g",{"id":"ffa3d1d8-9d44-4c20-bc1c-0341875bdc4b","data-name":"Layer 2","key":1},React.createElement("g",{"id":"a211acdb-6597-4e4b-833f-c5a8a3108e17","data-name":"Layer 1"},[React.createElement("path",{"className":"a6f244f0-8060-4ba8-a467-8f1a3dddc6f4","d":"M6,13l3-2.94A9.341,9.341,0,0,0,8,10c-2.67,0-8,1.34-8,4v2H9ZM8,8A4,4,0,1,0,4,4,4,4,0,0,0,8,8","key":0}),React.createElement("path",{"className":"a6f244f0-8060-4ba8-a467-8f1a3dddc6f4","d":"M12.47,16.5,9,13l1.4-1.41,2.07,2.08L17.6,8.5,19,9.91Z","key":1})]))]);
}

Register.defaultProps = {"width":"19","height":"16.5","viewBox":"0 0 19 16.5"};

module.exports = Register;

Register.default = Register;
